import classNames from 'classnames';
import React from 'react';

import styles from './styles.scss';

type BreadcrumbsLink = {
    href: string;
    title: string;
}

interface BreadcrumbsLinkProps {
    link: BreadcrumbsLink;
    hideSeparator?: boolean;
}

const BreadcrumbsLink = ({ link, hideSeparator }: BreadcrumbsLinkProps): JSX.Element => {
    return (
        <a className={styles.breadcrumbsLink} href={link.href}>
            <span>{link.title}</span>
            {!hideSeparator &&
                <span className={styles.separator}>/</span>
            }
        </a>
    );
}

interface Props {
    links: Array<BreadcrumbsLink>;
    className?: string;
}

const Breadcrumbs = ({ links, className }: Props): JSX.Element => {
    return (
        <nav className={classNames(className, styles.breadcrumbs)}>
            {links?.map((link, i) => (
                <BreadcrumbsLink
                    key={i}
                    link={link}
                    // hideSeparator={i === links.length - 1}
                />
            ))}
        </nav>
    );
};

export default Breadcrumbs;
